import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/event/modi/onlylive-logo.png'
import _imports_1 from '@/assets/img/event/modi/talk-ticket-top-img.png'
import _imports_2 from '@/assets/img/usecase01.png'
import _imports_3 from '@/assets/img/usecase02.png'
import _imports_4 from '@/assets/img/usecase03.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-43869fcd")

_pushScopeId("data-v-43869fcd")
const _hoisted_1 = { class: "modi-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lp-header" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "onlylive-img",
    src: _imports_0
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "modi-top-img" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "modi-image",
    src: _imports_1
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "congrats-content" }, [
  /*#__PURE__*/_createVNode("h2", null, "ご当選おめでとうございます"),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode("この度はonlylive Experience Event特別トークに"),
    /*#__PURE__*/_createVNode("br", { class: "sp" }),
    /*#__PURE__*/_createTextVNode("ご応募いただき、ありがとうございました。"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("下記内容をお読みになり、特別トークのお申し込みをお願いいたします。")
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("a", {
  class: "application-btn",
  href: "https://docs.google.com/forms/d/e/1FAIpQLScY_RZUZJVZKCQfI_wn49ovqcMow9W8BusNexavuTCtE81Yxg/viewform?usp=sf_link",
  target: "_blank"
}, "特別トークの申し込みはこちら", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "talk-ticket-howto" }, [
  /*#__PURE__*/_createVNode("h2", { class: "title" }, "特別トーク申し込み方法"),
  /*#__PURE__*/_createVNode("ul", { class: "talk-ticket-howto-list" }, [
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" ①メールアドレス、お名前、特別トーク対象タレント、"),
      /*#__PURE__*/_createVNode("br", { class: "sp" }),
      /*#__PURE__*/_createTextVNode("特典コードを"),
      /*#__PURE__*/_createVNode("br", { class: "pc" }),
      /*#__PURE__*/_createTextVNode("特別トーク申し込みフォームより"),
      /*#__PURE__*/_createVNode("br", { class: "sp" }),
      /*#__PURE__*/_createTextVNode("お送りください。"),
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode("3営業日以内にonlylive運営事務局から、"),
        /*#__PURE__*/_createVNode("br", { class: "sp" }),
        /*#__PURE__*/_createTextVNode("受け取り確認メールが届きます。")
      ])
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" ②2022年1月下旬までに、タレントとの"),
      /*#__PURE__*/_createVNode("br", { class: "sp" }),
      /*#__PURE__*/_createTextVNode("特別トーク候補をメールにてお送りします。"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("お日にちの確認をお願いいたします。"),
      /*#__PURE__*/_createVNode("p", null, "※指定の日時が難しい場合は相談可能です。")
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" ③特別トークの予約用シリアルコードが"),
      /*#__PURE__*/_createVNode("br", { class: "sp" }),
      /*#__PURE__*/_createTextVNode("メールにて届きます。"),
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode("onlyliveをダウンロード、アカウント登録を行い、"),
        /*#__PURE__*/_createVNode("br", { class: "sp" }),
        /*#__PURE__*/_createTextVNode("シリアルコード予約をしてください。")
      ])
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" ④特別トークの日時になりましたら、"),
      /*#__PURE__*/_createVNode("br", { class: "sp" }),
      /*#__PURE__*/_createTextVNode("onlyliveアプリを開き通話ボタンを押します。"),
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode("しばらくするとタレントと繋がりますので、"),
        /*#__PURE__*/_createVNode("br", { class: "sp" }),
        /*#__PURE__*/_createTextVNode("1対1のオンライン通話をお楽しみください。")
      ])
    ])
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("a", {
  class: "under-application-btn",
  href: "https://docs.google.com/forms/d/e/1FAIpQLScY_RZUZJVZKCQfI_wn49ovqcMow9W8BusNexavuTCtE81Yxg/viewform?usp=sf_link",
  target: "_blank"
}, "特別トーク申し込みフォーム", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "unsend-mail" }, [
  /*#__PURE__*/_createTextVNode("※メールが届かない場合は "),
  /*#__PURE__*/_createVNode("a", { href: "mailto:support@onlylive.jp" }, "support@onlylive.jp"),
  /*#__PURE__*/_createTextVNode("までご連絡ください")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "about-container" }, [
  /*#__PURE__*/_createVNode("h2", { class: "title" }, "onlyliveとは"),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode("onlyliveは、いつでもどこでも安心安全に"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("タレントと「1対1の会話」を楽しめるアプリです。"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("通話中に写真のリクエストをして、"),
    /*#__PURE__*/_createVNode("br", { class: "sp" }),
    /*#__PURE__*/_createTextVNode("世界に1枚だけの写真を手に入れることも。"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" タレントとの特別な思い出を、"),
    /*#__PURE__*/_createVNode("br", { class: "sp" }),
    /*#__PURE__*/_createTextVNode("いつでも思い返すことができます。")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "usecase" }, null, -1)
const _hoisted_11 = { class: "contents-usecase" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h3", { class: "txt title-usecase" }, "onlyliveの使い方", -1)
const _hoisted_13 = { class: "contents-use-case-group-sm" }
const _hoisted_14 = { class: "flow-box" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "step-img-request",
  src: _imports_2
}, null, -1)
const _hoisted_16 = { class: "flow-box" }
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  class: "step-img",
  src: _imports_3
}, null, -1)
const _hoisted_18 = { class: "flow-box" }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  class: "step-img",
  src: _imports_4
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("a", {
  class: "sp-only-btn",
  href: "https://onlylive.tokyo/howto",
  target: "_blank"
}, "詳しい使い方", -1)
const _hoisted_21 = { class: "contents-use-case-group-md" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "use-case-images" }, [
  /*#__PURE__*/_createVNode("div", { class: "use-case-image-box" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "step-img-request",
      src: _imports_2
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "use-case-image-box" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "step-img",
      src: _imports_3
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "use-case-image-box" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "step-img",
      src: _imports_4
    })
  ])
], -1)
const _hoisted_23 = { class: "use-case-items" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_UsecaseItem = _resolveComponent("UsecaseItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _createVNode("div", _hoisted_11, [
      _hoisted_12,
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_UsecaseItem, {
            headline: "STEP1",
            body: "通話を予約\n（先着順）",
            text: "通話予約できる人から通話したい人を選び、予約をしましょう。通話予約にはアプリ内で購入できるコインが必要なので、事前に購入しておくとスムーズです。"
          })
        ]),
        _createVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_UsecaseItem, {
            headline: "STEP2",
            body: "着信に応答して\n1体1の会話を楽しむ",
            text: "通話予約ごはタレントが電話をかけてくれるので見逃しません。2人きりの会話を楽しみましょう。",
            subText: "※タレントの映像のみが配信されます。\n※通話の様子は音声なしの状態で第三者からも閲覧可能です。"
          })
        ]),
        _createVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_UsecaseItem, {
            headline: "STEP3",
            body: "世界に1枚だけの\n写真をリクエスト",
            text: "通話中に、忘れずに写真のリクエストをしましょう。"
          })
        ])
      ]),
      _hoisted_20,
      _createVNode("div", _hoisted_21, [
        _hoisted_22,
        _createVNode("div", _hoisted_23, [
          _createVNode(_component_UsecaseItem, {
            headline: "STEP1",
            body: "通話を予約\n（先着順）",
            text: "通話予約できる人から通話したい人を選び、予約をしましょう。通話予約にはアプリ内で購入できるコインが必要なので、事前に購入しておくとスムーズです。"
          }),
          _createVNode(_component_UsecaseItem, {
            headline: "STEP2",
            body: "着信に応答して\n1体1の会話を楽しむ",
            text: "通話予約ごはタレントが電話をかけてくれるので見逃しません。2人きりの会話を楽しみましょう。",
            subText: "※タレントの映像のみが配信されます。\n※通話の様子は音声なしの状態で\n第三者からも閲覧可能です。"
          }),
          _createVNode(_component_UsecaseItem, {
            headline: "STEP3",
            body: "世界に1枚だけの\n写真をリクエスト",
            text: "通話中に、忘れずに写真のリクエストをしましょう。"
          })
        ])
      ])
    ])
  ]))
})